import ascending from "./ascending.js";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/order/descending.js
// module id = DVmH
// module chunks = 0